window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('.load-more-btn').length) {
    import('./_load-more.js').then((module) => {
      module.Init();
    });
  }
});
  
export default {}